import { rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = css`
  :host {
    --height: ${rem(48)};

    display: block;
    inline-size: 100%;
  }

  :host([fixedWidth]) {
    inline-size: ${rem(288)};
    --height: ${rem(32)};
  }

  /* We can't use CSS @layer's to overwrite the Bluebillywig CSS */
  /* so we're forced to resort to ugly !important's. */
  /* stylelint-disable declaration-no-important */
  .bbv {
    overflow: visible !important;
  }

  .bb_iawr {
    block-size: var(--height) !important;
    overflow: visible !important;
  }

  .bb_wrapper {
    block-size: var(--height) !important;
  }

  .bb-content-layer,
  .bb-context-layer,
  .bb-poster-layer {
    display: none;
  }

  .bb-layer {
    overflow: visible !important;
  }

  .bbv-zoom {
    display: none !important;
  }

  .bbv-auto-replay {
    display: none !important;
  }
`;
